// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"feb77a44","454":"8fdce16c","642":"4970a02f","751":"bd48745e","784":"4ab4ff1d"}[chunkId] + ".chunk.css";
};